export default __webpack_public_path__ + "static/media/bg9.5a5382d5.png";